<template>
  <h1>LOGGING OUT</h1>
</template>

<script>
export default {
  created() {
    this.$store.dispatch("auth/logout").then(() => {
      this.$router.push("/auth/signin");
    });
  }
};
</script>
